import React from "react";
import GradingIcon from "@mui/icons-material/Grading";

function ReviewButtonSmall(props) {
  return (
    <div
      className="square-button-mobile review-button-color"
      title="Revoke"
      onClick={props.handleOpen}
    >
      <GradingIcon style={{ color: "white" }} />
    </div>
  );
}

export default ReviewButtonSmall;
